import clsx from "clsx";
import React from "react";

export default function MonogramSettingHeader({ title, subtitlePrefix, subtitle, withPadding }) {
  return (
    <div
      className={clsx("monogram-setting", {
        "monogram-setting--no-title": !title && !withPadding,
      })}
    >
      {title && <h2 className="monogram-setting__title">{title}</h2>}
      <div className="monogram-setting__subtitle-container">
        {subtitlePrefix && subtitlePrefix.trim().length > 0 && (
          <h2 className="monogram-setting__subtitle">{subtitlePrefix}</h2>
        )}
        {subtitle && (
          <h2
            dangerouslySetInnerHTML={{ __html: subtitle }}
            className="monogram-setting__subtitle monogram-setting__subtitle--value"
          ></h2>
        )}
      </div>
    </div>
  );
}
